import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  theme: {
    themes: {
      light: {
        primary: '#105fc5',
        secondary: '#C13AC7',
        upvote: '#c6760f',
        danger: '#ff0000',
        success: '#008000',
        titles: '#000000',
      },
      dark: {
        primary: '#105fc5',
        secondary: '#C13AC7',
        upvote: '#c6760f',
        danger: '#ff0000',
        success: '#008000',
        titles: '#000000',
      },
    },
  },
})